import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=9186d9e8&scoped=true&"
import script from "./Related.vue?vue&type=script&async=true&lang=js&"
export * from "./Related.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Related.vue?vue&type=style&index=0&id=9186d9e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9186d9e8",
  null
  
)

export default component.exports